import './style.css';
import { checkAuthentication, setupAuthListener, startSessionMonitor } from './auth.ts';
import { startRouter, registerRoutes, registerNotFound } from './router.ts';

import { renderLoginPage } from './pages/login.ts';
import { renderDashboardPage } from './pages/dashboard.ts';
import { renderDatabasePage } from './pages/database.ts';
import { renderTeacherPage } from './pages/teachers.ts';
import { renderDataEditPage } from './pages/data_edit.ts';
import { renderDataPrintPage } from './pages/data_print.ts';
import { renderEditDetailsPage } from './pages/edit_details.ts';
import { renderTeacherEditPage } from './pages/teacher_edit.ts';
import { renderAddStudentPage } from './pages/add_student.ts';
import { renderAddTeacherPage } from './pages/add_teacher.ts';
import { renderAdmissionPage } from './pages/admission.ts';
import { renderClassControlPage } from './pages/class_control.ts';
import { renderPromotionPage } from './pages/promotion.ts';
import { renderActiveStudentUpdatePage } from './pages/active_student_update.ts';
import { renderRegDashboardPage } from './pages/reg_dashboard.ts';
import { renderPlaceholderPage } from './pages/placeholder.ts';
import { renderOtherSchoolDashboardPage } from './pages/other_school_dashboard.ts';
import { renderSeatPlanProPage } from './pages/seat_plan_pro.ts';
import { renderImageBackupPage } from './pages/image_backup.ts';
import { renderStudentLogInPage } from './pages/student_log_in.ts';

// Other School Result Suite imports
import { renderOtherSchoolResultEntryPage } from './pages/other_school/result_entry.ts';
import { renderOtherSchoolResultEntry9Page } from './pages/other_school/result_entry_9.ts';
import { renderOtherSchoolResultListPage } from './pages/other_school/result/list.ts';
import { renderOtherSchoolResultList9Page } from './pages/other_school/result/list_9.ts';
import { renderOtherSchoolResultDetailsPage } from './pages/other_school/result/details.ts';
import { renderOtherSchoolResultDetails9Page } from './pages/other_school/result/details_9.ts';
import { renderOtherSchoolResultEditPage } from './pages/other_school/result/edit.ts';
import { renderOtherSchoolResultEdit9Page } from './pages/other_school/result/edit_9.ts';

// Other School Admission & TC Suite imports
import { renderOtherSchoolAdmissionPage } from './pages/other_school/admission.ts';
import { renderOtherSchoolEditApplicationPage } from './pages/other_school/edit_application.ts';
import { renderOtherSchoolDownloadFormPage } from './pages/other_school/download_form.ts';
import { renderOtherSchoolEditDetailsPage } from './pages/other_school/edit_details.ts';
import { renderOtherSchoolDatabasePage } from './pages/other_school/database.ts';
import { renderOtherSchoolLoginPage } from './pages/other_school/login.ts';

import { renderOtherSchoolTcListPage } from './pages/other_school/tc/test_list.ts';
import { renderOtherSchoolTcEditFormPage } from './pages/other_school/tc/tc_edit_form.ts';
import { renderOtherSchoolTcWordPage } from './pages/other_school/tc/certificate_word.ts';
import { renderOtherSchoolTcPublicPage } from './pages/other_school/tc/public_info.ts';
/* ── Hide body until initialization ───────────── */
document.body.style.visibility = 'hidden';

/* ── Define SPA Routes ────────────────────────── */
registerRoutes([
  {
    path: '/',
    title: 'Super Admin Dashboard',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderDashboardPage(app);
    },
  },
  {
    path: '/login',
    title: 'Login - Dashboard',
    render: (app) => renderLoginPage(app),
  },
  {
    path: '/database',
    title: 'Database - Dashboard',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      renderDatabasePage(app);
    },
  },
  { path: '/database_2025', title: 'Database 2025', render: async (app) => { if (await checkAuthentication()) renderDatabasePage(app, '2025'); } },
  { path: '/database_old', title: 'Previous Database', render: async (app) => { if (await checkAuthentication()) renderDatabasePage(app, 'old'); } },
  { path: '/database_2024', title: 'Database 2024', render: async (app) => { if (await checkAuthentication()) renderDatabasePage(app, '2024'); } },
  { path: '/database_2023', title: 'Database 2023', render: async (app) => { if (await checkAuthentication()) renderDatabasePage(app, '2023'); } },
  { path: '/database_2022', title: 'Database 2022', render: async (app) => { if (await checkAuthentication()) renderDatabasePage(app, '2022'); } },
  {
    path: '/teacher',
    title: 'Teacher Database - Dashboard',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      renderTeacherPage(app);
    },
  },
  {
    path: '/all_data_field',
    title: 'All Data Fields',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      renderPlaceholderPage(app, 'All Data Fields');
    },
  },
  {
    path: '/data_edit',
    title: 'Bulk Data Edit',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      renderDataEditPage(app);
    },
  },
  {
    path: '/data_print',
    title: 'Data Print & Export',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      renderDataPrintPage(app);
    },
  },
  {
    path: '/edit_details',
    title: 'Edit Student Details',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      renderEditDetailsPage(app);
    },
  },
  {
    path: '/view',
    title: 'View Student Details',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      renderEditDetailsPage(app);
    },
  },
  {
    path: '/teacher_edit',
    title: 'Teacher Profile',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      renderTeacherEditPage(app);
    },
  },
  { path: '/addstudent', title: 'Add Student', render: async (app) => { if (await checkAuthentication()) renderAddStudentPage(app); } },
  { path: '/addteacher', title: 'Add Teacher', render: async (app) => { if (await checkAuthentication()) renderAddTeacherPage(app); } },
  { path: '/admission', title: 'Admission', render: async (app) => { if (await checkAuthentication()) renderAdmissionPage(app); } },
  { path: '/class_control', title: 'Class Control', render: async (app) => { if (await checkAuthentication()) renderClassControlPage(app); } },
  { path: '/promotion', title: 'Promotion', render: async (app) => { if (await checkAuthentication()) renderPromotionPage(app); } },
  { path: '/active_student_update', title: 'Update Students', render: async (app) => { if (await checkAuthentication()) renderActiveStudentUpdatePage(app); } },
  { path: '/reg_dashboard', title: 'Reg Form Dashboard', render: async (app) => { if (await checkAuthentication()) renderRegDashboardPage(app); } },
  { path: '/seat_plan_pro', title: 'ExamSeat Planner Pro', render: async (app) => { if (await checkAuthentication()) await renderSeatPlanProPage(app); } },
  { path: '/image_backup', title: 'Photo Backup — R2', render: async (app) => { if (await checkAuthentication()) await renderImageBackupPage(app); } },
  { path: '/student_log_in', title: 'Student Login Sync', render: async (app) => { if (await checkAuthentication()) await renderStudentLogInPage(app); } },
  {
    path: '/other_school_dashboard',
    title: 'Other School Dashboard',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolDashboardPage(app);
    },
  },
  {
    path: '/other_school/database',
    title: 'Student Database — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolDatabasePage(app);
    },
  },
  {
    path: '/other_school/login',
    title: 'School Login — Other School',
    render: async (app) => {
      await renderOtherSchoolLoginPage(app);
    },
  },
  {
    path: '/other_school/edit_details',
    title: 'Edit Student Details',
    render: async (app) => {
      renderOtherSchoolEditDetailsPage(app);
    }
  },
  {
    path: '/other_school/view',
    title: 'View Student Details',
    render: async (app) => {
      renderOtherSchoolEditDetailsPage(app);
    }
  },
  {
    path: '/other_school/result_entry',
    title: 'Result Entry — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolResultEntryPage(app);
    },
  },
  {
    path: '/other_school/result_entry_9',
    title: 'Result Entry (9-10) — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolResultEntry9Page(app);
    },
  },
  {
    path: '/other_school/result/list',
    title: 'Result List — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolResultListPage(app);
    },
  },
  {
    path: '/other_school/result/list_9',
    title: 'Result List (9-10) — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolResultList9Page(app);
    },
  },
  {
    path: '/other_school/result/details',
    title: 'Report Card — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolResultDetailsPage(app);
    },
  },
  {
    path: '/other_school/result/details_9',
    title: 'Report Card (9-10) — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolResultDetails9Page(app);
    },
  },
  {
    path: '/other_school/result/edit',
    title: 'Edit Result — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolResultEditPage(app);
    },
  },
  {
    path: '/other_school/result/edit_9',
    title: 'Edit Result (9-10) — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolResultEdit9Page(app);
    },
  },
  {
    path: '/other_school/admission',
    title: 'Admission — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolAdmissionPage(app);
    },
  },
  {
    path: '/other_school/edit_application',
    title: 'Edit Application — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolEditApplicationPage(app);
    },
  },
  {
    path: '/other_school/download_form',
    title: 'Download Form — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolDownloadFormPage(app);
    },
  },
  {
    path: '/other_school/edit_details',
    title: 'Edit Profile — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolEditDetailsPage(app);
    },
  },
  {
    path: '/other_school/tc',
    title: 'TC Verification — Other School',
    render: async (app) => {
      await renderOtherSchoolTcPublicPage(app);
    },
  },
  {
    path: '/other_school/tc/test_list',
    title: 'TC List — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolTcListPage(app);
    },
  },
  {
    path: '/other_school/tc/tc_edit_form',
    title: 'TC Issue — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolTcEditFormPage(app);
    },
  },
  {
    path: '/other_school/tc/certificate_word',
    title: 'Print TC — Other School',
    render: async (app) => {
      if (!(await checkAuthentication())) return;
      await renderOtherSchoolTcWordPage(app);
    },
  },
]);

registerNotFound((app) => {
  renderPlaceholderPage(app, 'Page Not Found');
});

/* ── Initialize ───────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  setupAuthListener();
  startSessionMonitor();
  
  // Show body
  document.body.style.visibility = 'visible';

  // Start the router
  startRouter();
});

export function escapeHtml(str: any): string {
  if (typeof str !== 'string') return String(str ?? '');
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
